export interface IAlert {
  text: string;
  type: string;
  cssClass?: string;
}
export class Alert implements IAlert {
  constructor(
    public text: string,
    public type: string,
    public cssClass?: string,
  ) {}
}
